export default __webpack_public_path__ + "static/media/Pistol_5.bf637b5b.png";